/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useAddFundsOut from '@hooks/useAddFundsOut';
import FormBankAccount from '@components/Forms/FormBankAccount';
import { FormBankAccountPe, FormBankAccountCo } from '@components';
import { getEnv } from '@config';
import { saparateDocSelected } from '@constants/bankAccountType';
import { isCountryPeru, isCountryChile } from '@constants/regions';

const AddBankAccount = () => {
  const { merchant } = useSelector((state) => state.login);
  const { accountTypes, bankNames } = useAddFundsOut();
  const [formDocs, setFormDocs] = useState([]);
  const { country } = getEnv();

  useEffect(() => {
    const docs = [];

    if (country === 'cl') {
      docs.push({
        value: merchant.document.doc_number,
        text: merchant.document.doc_number,
      });
    } else
      docs.push({
        value: `${merchant.document.doc_type}${saparateDocSelected}${merchant.document.doc_number}`,
        text: `${merchant.document.doc_type}${saparateDocSelected}${merchant.document.doc_number}`,
      });

    if (merchant.legal_agent.document.doc_number !== merchant.document.doc_number) {
      if (country === 'cl') {
        docs.push({
          value: merchant.legal_agent.document.doc_number,
          text: merchant.legal_agent.document.doc_number,
        });
      } else {
        docs.push({
          value: `${merchant.legal_agent.document.doc_type}${saparateDocSelected}${merchant.legal_agent.document.doc_number}`,
          text: `${merchant.legal_agent.document.doc_type}${saparateDocSelected}${merchant.legal_agent.document.doc_number}`,
        });
      }
    }
    setFormDocs(docs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchant]);

  return (
    <>
      {isCountryChile ? (
        <FormBankAccount ruts={formDocs} accountTypes={accountTypes} bankNames={bankNames} />
      ) : isCountryPeru ? (
        <FormBankAccountPe docs={formDocs} />
      ) : (
        <FormBankAccountCo docs={formDocs} />
      )}
    </>
  );
};

export default AddBankAccount;
